import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

function AddConvenioFinisa() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [form, setForm] = useState({
    objeto: "",
    objeto_completo: "",
    cp_dl_tp: "",
    contrato: "",
    ano: "",
    valor_total: "",
    empresa: "",
    status: "",
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/conveniosfinisa/${id}`)
        .then((res) => {
          setForm(res.data);
        })
        .catch((err) => {
          console.error(err);
          alert("Erro ao carregar dados do convênio");
        });
    }
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleValueChange = (name, values) => {
    const { value } = values;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (id) {
      axios
        .put(`/api/conveniosfinisa/${id}`, form)
        .then((res) => {
          if (res.data.Status === "Success") {
            alert("Convênio FINISA atualizado com sucesso!");
            navigate("/conveniosfinisa");
          } else {
            alert("Erro ao atualizar convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    } else {
      axios
        .post("/api/conveniosfinisa", form)
        .then((res) => {
          if (res.data.Status === "Success") {
            alert("Convênio FINISA criado com sucesso!");
            navigate("/conveniosfinisa");
          } else {
            alert("Erro ao criar convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="px-4 py-3">
      <h3 className="mb-4">
        {id ? "Editar Convênio FINISA" : "Adicionar Convênio FINISA"}
      </h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Objeto</label>
          <input
            type="text"
            name="objeto"
            className="form-control"
            required
            value={form.objeto}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Objeto Completo</label>
          <input
            type="text"
            name="objeto_completo"
            className="form-control"
            required
            value={form.objeto_completo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>CP/DL/TP</label>
          <input
            type="text"
            name="cp_dl_tp"
            className="form-control"
            required
            value={form.cp_dl_tp}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Contrato</label>
          <input
            type="text"
            name="contrato"
            className="form-control"
            required
            value={form.contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Ano</label>
          <input
            type="text"
            name="ano"
            className="form-control"
            required
            value={form.ano}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Valor Total</label>
          <NumericFormat
            name="valor_total"
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            value={form.valor_total}
            onValueChange={(values) => handleValueChange("valor_total", values)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Empresa</label>
          <input
            type="text"
            name="empresa"
            className="form-control"
            required
            value={form.empresa}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Status</label>
          <input
            type="text"
            name="status"
            className="form-control"
            required
            value={form.status}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          {id ? "Atualizar Convênio" : "Salvar Convênio"}
        </button>
      </form>
    </div>
  );
}

export default AddConvenioFinisa;
